<fa-icon [icon]="angleDown" transform="rotate-{{ open ? 180 : 0 }}"></fa-icon>
